<template>
  <div>
    <modal id="authenticationModal" v-model="modal" :append-to-body="true" :backdrop="false"
           class="skintestblock">
      <h4 slot="title" class="smalltitle">Enable Authentication {{ dataProofing.fullName }}</h4>
      <div v-if="!canSendLink">
          <div class="message-error-authentication" v-html="messageError"></div>
      </div>
      <div v-if="dataProofing.kycData && dataProofing.kycData.methods" class="block-verification" >
        <ul>
          <li v-for="item in dataProofing.kycData.methods">
            <div class="item-verification-method">{{ item.verificationMethod }}</div>
            <div class="item-status">{{ item.status }}</div>
            <div class="item-date-method">{{ formatFullTime12Hour(item.eventDate) }}</div>
          </li>
        </ul>

      </div>
      <div v-if="dataProofing.link && canSendLink" class="input-group">
        <input v-model="dataProofing.link" class="form-control input-field" readonly type="text">
        <div class="input-group-append">
          <button class="copy-btn" type="button" @click="copyToClipboard">
            Copy
          </button>
        </div>

        <div style="margin-top: 10px;" v-if="canSendLink">
            <span style="margin-right: 10px;">
              <input :id="'sms-type'" v-model="typeSends"
                     :value="'sms'"
                     name="send-type" type="checkbox">
            <label :for="'sms-type'">&nbsp;SMS {{ '(' + formatPhone(dataProofing.phone) + ')' }}</label>
            </span>

          <!--            <input :id="'email-type'" :value="'email'"-->
          <!--                   name="send-type"-->
          <!--                   type="checkbox" v-model="typeSends">-->
          <!--            <label :for="'email-type'">&nbsp;EMAIL {{'(' + dataProofing.email + ')'}}</label>-->
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" type="button" @click.prevent="sendLinkIdProof" v-if="canSendLink">
          <i v-if="processingStatus" class="fas fa-spinner fa-spin"></i> Send Link Id Proof
        </button>
        <button v-if="!dataProofing.enableIdProofing && canSendLink" class="btn btn-default" type="button"
                @click.prevent="enableIdProofing">
          <i v-if="processingStatus" class="fas fa-spinner fa-spin"></i> Enable Id Proofing
        </button>
        <button class="btn btn-default" type="button" @click.prevent="closeModal">Close
        </button>
      </div>
    </modal>
  </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'AuthenticationModal',
  components: {},
  props: {
    user: { required: true }
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      processingStatus: false,
      dataProofing: {
        link: '',
        enableIdProofing: false,
        kycData: null,
        phone: '',
        email: '',
        fullName: ''
      },
      dataUser: null,
      typeSends: []
    }
  },
  computed: {
    messageError () {
      if (this.canSendLink) {
        return ''
      }
      let messageError = ``
      if (!this.dataUser.birthday) {
        messageError += `Please update your birthday at your profile <br>`
      }
      if (!this.dataUser.email) {
        messageError += `Please update your email at your profile <br>`
      }
      if (!this.dataUser.firstName) {
        messageError += `Please update your First Name at your profile <br>`
      }
      if (!this.dataUser.lastName) {
        messageError += `Please update your Last Name at your profile <br>`
      }
      return messageError
    },
    canSendLink () {
      if (this.dataUser) {
        if (!this.dataUser.birthday || !this.dataUser.email || !this.dataUser.firstName || !this.dataUser.lastName) {
          return false
        }
      }
      return true
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getInfoIdProofing()
  },
  beforeDestroy () {
  },
  methods: {
    async sendLinkIdProof () {
      if (this.processingStatus) {
        return
      }
      if (this.typeSends.length === 0) {
        this.alertError('Please choose type of sending')
        return
      }
      try {
        let data = {
          userId: this.user.id,
          typeSends: this.typeSends
        }
        this.processingStatus = true
        let response = await httpClient.post(`/users/send-id-proofing`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.alertSuccess(response.data.msg)
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error')
      }
    },
    async copyToClipboard () {
      await navigator.clipboard.writeText(this.dataProofing.link)
    },
    async getInfoIdProofing () {
      try {
        let response = await httpClient.get(`/users/id-proofing-state/${this.user.id}`)
        if (response.data.s === 200) {
          this.dataProofing.enableIdProofing = response.data.data.enableIdProofing
          this.dataProofing.link = response.data.data.link
          this.dataProofing.kycData = response.data.data.kycData
          this.dataProofing.phone = response.data.data.phone
          this.dataProofing.email = response.data.data.email
          this.dataProofing.fullName = response.data.data.fullName
          this.dataUser = response.data.data.user
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    },
    async enableIdProofing () {
      if (this.processingStatus) {
        return
      }
      try {
        let data = {
          userId: this.user.id
        }
        this.processingStatus = true
        let response = await httpClient.put(`/users/enable-id-proofing`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.dataProofing.link = response.data.data.link
          this.dataProofing.enableIdProofing = true
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error')
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style scoped="">
/* Style for input group */
.input-group {
  position: relative;
  width: 75% !important;
}

/* Style for input field */
.input-field {
  border-radius: 5px;
  width: 100%;
}

.item-verification-method {
  width: 30%;
  display: inline-block;
}

.item-status {
  padding-left: 10px;
  width: 30%;
  display: inline-block;
}

.item-date-method {
  width: 30%;
  display: inline-block;
}

/* Style for copy button */
.copy-btn {
  position: absolute;
  right: -70px;
  top: 6px;
  border: none;
  background-color: #d9df20;
  color: white;
  padding: 8px 12px;
  font-size: 16px;
  cursor: pointer;
  z-index: 999999999999999999999;
}

/* Style for copy button on hover */
.copy-btn:hover {
  background-color: #3e8e41;
}
.message-error-authentication {
  color: red;
}
</style>
